export const shopifyCurrencyCodeEnumOptions = [
  { name: "AED" },
  { name: "AFN" },
  { name: "ALL" },
  { name: "AMD" },
  { name: "ANG" },
  { name: "AOA" },
  { name: "ARS" },
  { name: "AUD" },
  { name: "AWG" },
  { name: "AZN" },
  { name: "BAM" },
  { name: "BBD" },
  { name: "BDT" },
  { name: "BGN" },
  { name: "BHD" },
  { name: "BIF" },
  { name: "BMD" },
  { name: "BND" },
  { name: "BOB" },
  { name: "BRL" },
  { name: "BSD" },
  { name: "BTN" },
  { name: "BWP" },
  { name: "BYN" },
  { name: "BYR" },
  { name: "BZD" },
  { name: "CAD" },
  { name: "CDF" },
  { name: "CHF" },
  { name: "CLP" },
  { name: "CNY" },
  { name: "COP" },
  { name: "CRC" },
  { name: "CVE" },
  { name: "CZK" },
  { name: "DJF" },
  { name: "DKK" },
  { name: "DOP" },
  { name: "DZD" },
  { name: "EGP" },
  { name: "ERN" },
  { name: "ETB" },
  { name: "EUR" },
  { name: "FJD" },
  { name: "FKP" },
  { name: "GBP" },
  { name: "GEL" },
  { name: "GHS" },
  { name: "GIP" },
  { name: "GMD" },
  { name: "GNF" },
  { name: "GTQ" },
  { name: "GYD" },
  { name: "HKD" },
  { name: "HNL" },
  { name: "HRK" },
  { name: "HTG" },
  { name: "HUF" },
  { name: "IDR" },
  { name: "ILS" },
  { name: "INR" },
  { name: "IQD" },
  { name: "IRR" },
  { name: "ISK" },
  { name: "JEP" },
  { name: "JMD" },
  { name: "JOD" },
  { name: "JPY" },
  { name: "KES" },
  { name: "KGS" },
  { name: "KHR" },
  { name: "KID" },
  { name: "KMF" },
  { name: "KRW" },
  { name: "KWD" },
  { name: "KYD" },
  { name: "KZT" },
  { name: "LAK" },
  { name: "LBP" },
  { name: "LKR" },
  { name: "LRD" },
  { name: "LSL" },
  { name: "LTL" },
  { name: "LVL" },
  { name: "LYD" },
  { name: "MAD" },
  { name: "MDL" },
  { name: "MGA" },
  { name: "MKD" },
  { name: "MMK" },
  { name: "MNT" },
  { name: "MOP" },
  { name: "MRU" },
  { name: "MUR" },
  { name: "MVR" },
  { name: "MWK" },
  { name: "MXN" },
  { name: "MYR" },
  { name: "MZN" },
  { name: "NAD" },
  { name: "NGN" },
  { name: "NIO" },
  { name: "NOK" },
  { name: "NPR" },
  { name: "NZD" },
  { name: "OMR" },
  { name: "PAB" },
  { name: "PEN" },
  { name: "PGK" },
  { name: "PHP" },
  { name: "PKR" },
  { name: "PLN" },
  { name: "PYG" },
  { name: "QAR" },
  { name: "RON" },
  { name: "RSD" },
  { name: "RUB" },
  { name: "RWF" },
  { name: "SAR" },
  { name: "SBD" },
  { name: "SCR" },
  { name: "SDG" },
  { name: "SEK" },
  { name: "SGD" },
  { name: "SHP" },
  { name: "SLL" },
  { name: "SOS" },
  { name: "SRD" },
  { name: "SSP" },
  { name: "STD" },
  { name: "STN" },
  { name: "SYP" },
  { name: "SZL" },
  { name: "THB" },
  { name: "TJS" },
  { name: "TMT" },
  { name: "TND" },
  { name: "TOP" },
  { name: "TRY" },
  { name: "TTD" },
  { name: "TWD" },
  { name: "TZS" },
  { name: "UAH" },
  { name: "UGX" },
  { name: "USD" },
  { name: "USDC" },
  { name: "UYU" },
  { name: "UZS" },
  { name: "VED" },
  { name: "VEF" },
  { name: "VES" },
  { name: "VND" },
  { name: "VUV" },
  { name: "WST" },
  { name: "XAF" },
  { name: "XCD" },
  { name: "XOF" },
  { name: "XPF" },
  { name: "XXX" },
  { name: "YER" },
  { name: "ZAR" },
  { name: "ZMW" },
];

export const shopifyCountryCodeEnumOptions = [
  { name: "AC" },
  { name: "AD" },
  { name: "AE" },
  { name: "AF" },
  { name: "AG" },
  { name: "AI" },
  { name: "AL" },
  { name: "AM" },
  { name: "AN" },
  { name: "AO" },
  { name: "AR" },
  { name: "AT" },
  { name: "AU" },
  { name: "AW" },
  { name: "AX" },
  { name: "AZ" },
  { name: "BA" },
  { name: "BB" },
  { name: "BD" },
  { name: "BE" },
  { name: "BF" },
  { name: "BG" },
  { name: "BH" },
  { name: "BI" },
  { name: "BJ" },
  { name: "BL" },
  { name: "BM" },
  { name: "BN" },
  { name: "BO" },
  { name: "BQ" },
  { name: "BR" },
  { name: "BS" },
  { name: "BT" },
  { name: "BV" },
  { name: "BW" },
  { name: "BY" },
  { name: "BZ" },
  { name: "CA" },
  { name: "CC" },
  { name: "CD" },
  { name: "CF" },
  { name: "CG" },
  { name: "CH" },
  { name: "CI" },
  { name: "CK" },
  { name: "CL" },
  { name: "CM" },
  { name: "CN" },
  { name: "CO" },
  { name: "CR" },
  { name: "CU" },
  { name: "CV" },
  { name: "CW" },
  { name: "CX" },
  { name: "CY" },
  { name: "CZ" },
  { name: "DE" },
  { name: "DJ" },
  { name: "DK" },
  { name: "DM" },
  { name: "DO" },
  { name: "DZ" },
  { name: "EC" },
  { name: "EE" },
  { name: "EG" },
  { name: "EH" },
  { name: "ER" },
  { name: "ES" },
  { name: "ET" },
  { name: "FI" },
  { name: "FJ" },
  { name: "FK" },
  { name: "FO" },
  { name: "FR" },
  { name: "GA" },
  { name: "GB" },
  { name: "GD" },
  { name: "GE" },
  { name: "GF" },
  { name: "GG" },
  { name: "GH" },
  { name: "GI" },
  { name: "GL" },
  { name: "GM" },
  { name: "GN" },
  { name: "GP" },
  { name: "GQ" },
  { name: "GR" },
  { name: "GS" },
  { name: "GT" },
  { name: "GW" },
  { name: "GY" },
  { name: "HK" },
  { name: "HM" },
  { name: "HN" },
  { name: "HR" },
  { name: "HT" },
  { name: "HU" },
  { name: "ID" },
  { name: "IE" },
  { name: "IL" },
  { name: "IM" },
  { name: "IN" },
  { name: "IO" },
  { name: "IQ" },
  { name: "IR" },
  { name: "IS" },
  { name: "IT" },
  { name: "JE" },
  { name: "JM" },
  { name: "JO" },
  { name: "JP" },
  { name: "KE" },
  { name: "KG" },
  { name: "KH" },
  { name: "KI" },
  { name: "KM" },
  { name: "KN" },
  { name: "KP" },
  { name: "KR" },
  { name: "KW" },
  { name: "KY" },
  { name: "KZ" },
  { name: "LA" },
  { name: "LB" },
  { name: "LC" },
  { name: "LI" },
  { name: "LK" },
  { name: "LR" },
  { name: "LS" },
  { name: "LT" },
  { name: "LU" },
  { name: "LV" },
  { name: "LY" },
  { name: "MA" },
  { name: "MC" },
  { name: "MD" },
  { name: "ME" },
  { name: "MF" },
  { name: "MG" },
  { name: "MK" },
  { name: "ML" },
  { name: "MM" },
  { name: "MN" },
  { name: "MO" },
  { name: "MQ" },
  { name: "MR" },
  { name: "MS" },
  { name: "MT" },
  { name: "MU" },
  { name: "MV" },
  { name: "MW" },
  { name: "MX" },
  { name: "MY" },
  { name: "MZ" },
  { name: "NA" },
  { name: "NC" },
  { name: "NE" },
  { name: "NF" },
  { name: "NG" },
  { name: "NI" },
  { name: "NL" },
  { name: "NO" },
  { name: "NP" },
  { name: "NR" },
  { name: "NU" },
  { name: "NZ" },
  { name: "OM" },
  { name: "PA" },
  { name: "PE" },
  { name: "PF" },
  { name: "PG" },
  { name: "PH" },
  { name: "PK" },
  { name: "PL" },
  { name: "PM" },
  { name: "PN" },
  { name: "PS" },
  { name: "PT" },
  { name: "PY" },
  { name: "QA" },
  { name: "RE" },
  { name: "RO" },
  { name: "RS" },
  { name: "RU" },
  { name: "RW" },
  { name: "SA" },
  { name: "SB" },
  { name: "SC" },
  { name: "SD" },
  { name: "SE" },
  { name: "SG" },
  { name: "SH" },
  { name: "SI" },
  { name: "SJ" },
  { name: "SK" },
  { name: "SL" },
  { name: "SM" },
  { name: "SN" },
  { name: "SO" },
  { name: "SR" },
  { name: "SS" },
  { name: "ST" },
  { name: "SV" },
  { name: "SX" },
  { name: "SY" },
  { name: "SZ" },
  { name: "TA" },
  { name: "TC" },
  { name: "TD" },
  { name: "TF" },
  { name: "TG" },
  { name: "TH" },
  { name: "TJ" },
  { name: "TK" },
  { name: "TL" },
  { name: "TM" },
  { name: "TN" },
  { name: "TO" },
  { name: "TR" },
  { name: "TT" },
  { name: "TV" },
  { name: "TW" },
  { name: "TZ" },
  { name: "UA" },
  { name: "UG" },
  { name: "UM" },
  { name: "US" },
  { name: "UY" },
  { name: "UZ" },
  { name: "VA" },
  { name: "VC" },
  { name: "VE" },
  { name: "VG" },
  { name: "VN" },
  { name: "VU" },
  { name: "WF" },
  { name: "WS" },
  { name: "XK" },
  { name: "YE" },
  { name: "YT" },
  { name: "ZA" },
  { name: "ZM" },
  { name: "ZW" },
  { name: "ZZ" },
];

export const shopifyTaxExemptionsEnumOptions = [
  { name: "CA_BC_COMMERCIAL_FISHERY_EXEMPTION" },
  { name: "CA_BC_CONTRACTOR_EXEMPTION" },
  { name: "CA_BC_PRODUCTION_AND_MACHINERY_EXEMPTION" },
  { name: "CA_BC_RESELLER_EXEMPTION" },
  { name: "CA_BC_SUB_CONTRACTOR_EXEMPTION" },
  { name: "CA_DIPLOMAT_EXEMPTION" },
  { name: "CA_MB_COMMERCIAL_FISHERY_EXEMPTION" },
  { name: "CA_MB_FARMER_EXEMPTION" },
  { name: "CA_MB_RESELLER_EXEMPTION" },
  { name: "CA_NS_COMMERCIAL_FISHERY_EXEMPTION" },
  { name: "CA_NS_FARMER_EXEMPTION" },
  { name: "CA_ON_PURCHASE_EXEMPTION" },
  { name: "CA_PE_COMMERCIAL_FISHERY_EXEMPTION" },
  { name: "CA_SK_COMMERCIAL_FISHERY_EXEMPTION" },
  { name: "CA_SK_CONTRACTOR_EXEMPTION" },
  { name: "CA_SK_FARMER_EXEMPTION" },
  { name: "CA_SK_PRODUCTION_AND_MACHINERY_EXEMPTION" },
  { name: "CA_SK_RESELLER_EXEMPTION" },
  { name: "CA_SK_SUB_CONTRACTOR_EXEMPTION" },
  { name: "CA_STATUS_CARD_EXEMPTION" },
  { name: "EU_REVERSE_CHARGE_EXEMPTION_RULE" },
  { name: "US_AK_RESELLER_EXEMPTION" },
  { name: "US_AL_RESELLER_EXEMPTION" },
  { name: "US_AR_RESELLER_EXEMPTION" },
  { name: "US_AZ_RESELLER_EXEMPTION" },
  { name: "US_CA_RESELLER_EXEMPTION" },
  { name: "US_CO_RESELLER_EXEMPTION" },
  { name: "US_CT_RESELLER_EXEMPTION" },
  { name: "US_DC_RESELLER_EXEMPTION" },
  { name: "US_DE_RESELLER_EXEMPTION" },
  { name: "US_FL_RESELLER_EXEMPTION" },
  { name: "US_GA_RESELLER_EXEMPTION" },
  { name: "US_HI_RESELLER_EXEMPTION" },
  { name: "US_IA_RESELLER_EXEMPTION" },
  { name: "US_ID_RESELLER_EXEMPTION" },
  { name: "US_IL_RESELLER_EXEMPTION" },
  { name: "US_IN_RESELLER_EXEMPTION" },
  { name: "US_KS_RESELLER_EXEMPTION" },
  { name: "US_KY_RESELLER_EXEMPTION" },
  { name: "US_LA_RESELLER_EXEMPTION" },
  { name: "US_MA_RESELLER_EXEMPTION" },
  { name: "US_MD_RESELLER_EXEMPTION" },
  { name: "US_ME_RESELLER_EXEMPTION" },
  { name: "US_MI_RESELLER_EXEMPTION" },
  { name: "US_MN_RESELLER_EXEMPTION" },
  { name: "US_MO_RESELLER_EXEMPTION" },
  { name: "US_MS_RESELLER_EXEMPTION" },
  { name: "US_MT_RESELLER_EXEMPTION" },
  { name: "US_NC_RESELLER_EXEMPTION" },
  { name: "US_ND_RESELLER_EXEMPTION" },
  { name: "US_NE_RESELLER_EXEMPTION" },
  { name: "US_NH_RESELLER_EXEMPTION" },
  { name: "US_NJ_RESELLER_EXEMPTION" },
  { name: "US_NM_RESELLER_EXEMPTION" },
  { name: "US_NV_RESELLER_EXEMPTION" },
  { name: "US_NY_RESELLER_EXEMPTION" },
  { name: "US_OH_RESELLER_EXEMPTION" },
  { name: "US_OK_RESELLER_EXEMPTION" },
  { name: "US_OR_RESELLER_EXEMPTION" },
  { name: "US_PA_RESELLER_EXEMPTION" },
  { name: "US_RI_RESELLER_EXEMPTION" },
  { name: "US_SC_RESELLER_EXEMPTION" },
  { name: "US_SD_RESELLER_EXEMPTION" },
  { name: "US_TN_RESELLER_EXEMPTION" },
  { name: "US_TX_RESELLER_EXEMPTION" },
  { name: "US_UT_RESELLER_EXEMPTION" },
  { name: "US_VA_RESELLER_EXEMPTION" },
  { name: "US_VT_RESELLER_EXEMPTION" },
  { name: "US_WA_RESELLER_EXEMPTION" },
  { name: "US_WI_RESELLER_EXEMPTION" },
  { name: "US_WV_RESELLER_EXEMPTION" },
  { name: "US_WY_RESELLER_EXEMPTION" },
];
export const shopifyPaymentsTransactionTypeEnumOptions = [
  { name: "ADS_PUBLISHER_CREDIT" },
  { name: "ADS_PUBLISHER_CREDIT_REVERSAL" },
  { name: "LENDING_DEBIT" },
  { name: "LENDING_DEBIT_REVERSAL" },
  { name: "LENDING_CREDIT" },
  { name: "LENDING_CREDIT_REVERSAL" },
  { name: "LENDING_CAPITAL_REMITTANCE" },
  { name: "LENDING_CAPITAL_REMITTANCE_REVERSAL" },
  { name: "LENDING_CREDIT_REMITTANCE" },
  { name: "LENDING_CREDIT_REMITTANCE_REVERSAL" },
  { name: "LENDING_CAPITAL_REFUND" },
  { name: "LENDING_CAPITAL_REFUND_REVERSAL" },
  { name: "LENDING_CREDIT_REFUND" },
  { name: "LENDING_CREDIT_REFUND_REVERSAL" },
  { name: "ADJUSTMENT" },
  { name: "ADVANCE" },
  { name: "ADVANCE_FUNDING" },
  { name: "ANOMALY_CREDIT" },
  { name: "ANOMALY_CREDIT_REVERSAL" },
  { name: "ANOMALY_DEBIT" },
  { name: "ANOMALY_DEBIT_REVERSAL" },
  { name: "APPLICATION_FEE_REFUND" },
  { name: "BALANCE_TRANSFER_INBOUND" },
  { name: "BILLING_DEBIT" },
  { name: "BILLING_DEBIT_REVERSAL" },
  { name: "CHANNEL_CREDIT" },
  { name: "CHANNEL_CREDIT_REVERSAL" },
  { name: "CHANNEL_PROMOTION_CREDIT" },
  { name: "CHANNEL_PROMOTION_CREDIT_REVERSAL" },
  { name: "CHANNEL_TRANSFER_CREDIT" },
  { name: "CHANNEL_TRANSFER_CREDIT_REVERSAL" },
  { name: "CHANNEL_TRANSFER_DEBIT" },
  { name: "CHANNEL_TRANSFER_DEBIT_REVERSAL" },
  { name: "CHARGE" },
  { name: "CHARGEBACK_FEE" },
  { name: "CHARGEBACK_FEE_REFUND" },
  { name: "CHARGEBACK_HOLD" },
  { name: "CHARGEBACK_HOLD_RELEASE" },
  { name: "CHARGEBACK_PROTECTION_CREDIT" },
  { name: "CHARGEBACK_PROTECTION_CREDIT_REVERSAL" },
  { name: "CHARGEBACK_PROTECTION_DEBIT" },
  { name: "CHARGEBACK_PROTECTION_DEBIT_REVERSAL" },
  { name: "CHARGE_ADJUSTMENT" },
  { name: "COLLECTIONS_CREDIT" },
  { name: "COLLECTIONS_CREDIT_REVERSAL" },
  { name: "CUSTOMS_DUTY" },
  { name: "CUSTOMS_DUTY_ADJUSTMENT" },
  { name: "DISPUTE_REVERSAL" },
  { name: "DISPUTE_WITHDRAWAL" },
  { name: "IMPORT_TAX" },
  { name: "IMPORT_TAX_ADJUSTMENT" },
  { name: "IMPORT_TAX_REFUND" },
  { name: "MARKETPLACE_FEE_CREDIT" },
  { name: "MARKETPLACE_FEE_CREDIT_REVERSAL" },
  { name: "MARKETS_PRO_CREDIT" },
  { name: "MERCHANT_GOODWILL_CREDIT" },
  { name: "MERCHANT_GOODWILL_CREDIT_REVERSAL" },
  { name: "MERCHANT_TO_MERCHANT_CREDIT" },
  { name: "MERCHANT_TO_MERCHANT_CREDIT_REVERSAL" },
  { name: "MERCHANT_TO_MERCHANT_DEBIT" },
  { name: "MERCHANT_TO_MERCHANT_DEBIT_REVERSAL" },
  { name: "PROMOTION_CREDIT" },
  { name: "PROMOTION_CREDIT_REVERSAL" },
  { name: "REFUND" },
  { name: "REFUND_ADJUSTMENT" },
  { name: "REFUND_FAILURE" },
  { name: "RESERVED_FUNDS" },
  { name: "RESERVED_FUNDS_REVERSAL" },
  { name: "RESERVED_FUNDS_WITHDRAWAL" },
  { name: "RISK_REVERSAL" },
  { name: "RISK_WITHDRAWAL" },
  { name: "SELLER_PROTECTION_CREDIT" },
  { name: "SELLER_PROTECTION_CREDIT_REVERSAL" },
  { name: "SHIPPING_LABEL" },
  { name: "SHIPPING_LABEL_ADJUSTMENT" },
  { name: "SHIPPING_LABEL_ADJUSTMENT_BASE" },
  { name: "SHIPPING_LABEL_ADJUSTMENT_SURCHARGE" },
  { name: "SHIPPING_OTHER_CARRIER_CHARGE_ADJUSTMENT" },
  { name: "SHIPPING_RETURN_TO_ORIGIN_ADJUSTMENT" },
  { name: "SHOPIFY_COLLECTIVE_CREDIT" },
  { name: "SHOPIFY_COLLECTIVE_CREDIT_REVERSAL" },
  { name: "SHOPIFY_COLLECTIVE_DEBIT" },
  { name: "SHOPIFY_COLLECTIVE_DEBIT_REVERSAL" },
  { name: "SHOPIFY_SOURCE_CREDIT" },
  { name: "SHOPIFY_SOURCE_CREDIT_REVERSAL" },
  { name: "SHOPIFY_SOURCE_DEBIT" },
  { name: "SHOPIFY_SOURCE_DEBIT_REVERSAL" },
  { name: "SHOP_CASH_BILLING_DEBIT" },
  { name: "SHOP_CASH_BILLING_DEBIT_REVERSAL" },
  { name: "SHOP_CASH_CAMPAIGN_BILLING_CREDIT" },
  { name: "SHOP_CASH_CAMPAIGN_BILLING_CREDIT_REVERSAL" },
  { name: "SHOP_CASH_CAMPAIGN_BILLING_DEBIT" },
  { name: "SHOP_CASH_CAMPAIGN_BILLING_DEBIT_REVERSAL" },
  { name: "SHOP_CASH_CREDIT" },
  { name: "SHOP_CASH_CREDIT_REVERSAL" },
  { name: "SHOP_CASH_REFUND_DEBIT" },
  { name: "SHOP_CASH_REFUND_DEBIT_REVERSAL" },
  { name: "STRIPE_FEE" },
  { name: "TAX_ADJUSTMENT_CREDIT" },
  { name: "TAX_ADJUSTMENT_CREDIT_REVERSAL" },
  { name: "TAX_ADJUSTMENT_DEBIT" },
  { name: "TAX_ADJUSTMENT_DEBIT_REVERSAL" },
  { name: "TRANSFER" },
  { name: "TRANSFER_CANCEL" },
  { name: "TRANSFER_FAILURE" },
  { name: "TRANSFER_REFUND" },
  { name: "VAT_REFUND_CREDIT" },
  { name: "VAT_REFUND_CREDIT_REVERSAL" },
];

// useful for mapping the graphql moneybag field to match the rest shape (when the model has webhooks which include the moneybag field in rest snake case format)
export const graphqlMoneyBagFieldToRest = `
  shop_money:shopMoney {
    amount
    currency_code:currencyCode
  }
  presentment_money:presentmentMoney {
    amount
    currency_code:currencyCode
  }
`;

export const graphqlMoneyBagField = `
  shopMoney {
    amount
    currencyCode
  }
  presentmentMoney {
    amount
    currencyCode
  }
`;
